import { useController } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import PropTypes from "prop-types";

const FormDateTimePicker = ({ name, label, ...otherProps }) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    defaultValue: null,
  });

  return (
    <DateTimePicker
      {...field}
      label={label}
      slotProps={{
        textField: {
          error: !!error,
          helperText: error?.message,
        },
      }}
      {...otherProps}
    />
  );
};

FormDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FormDateTimePicker;
